import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
import noop from 'lodash/fp/noop';
import Switch from '../switch/Switch';
const TreeOption = (props) => {
    const { isChecked = false, className, label, onChange = noop } = props, remainingProps = __rest(props, ["isChecked", "className", "label", "onChange"]);
    const optionClasses = classNames('TreeOption', 'display-flex', 'justify-content-start', 'align-items-center', 'gap-10', 'cursor-pointer', className);
    return (_jsxs("div", Object.assign({}, remainingProps, { className: optionClasses, onClick: onChange }, { children: [_jsx("span", Object.assign({ className: 'flex-1-1' }, { children: label })), _jsx("span", Object.assign({ className: 'pointer-events-none scale-80' }, { children: _jsx(Switch, { keyName: 'TreeOption-switch', checked: isChecked }) }))] })));
};
export default TreeOption;
